__turbopack_context__.v({
  "article_card": "styles-module-scss-module__3MbW6a__article_card",
  "article_card_container": "styles-module-scss-module__3MbW6a__article_card_container",
  "article_card_content": "styles-module-scss-module__3MbW6a__article_card_content",
  "article_card_top": "styles-module-scss-module__3MbW6a__article_card_top",
  "article_eyebrow": "styles-module-scss-module__3MbW6a__article_eyebrow",
  "article_image": "styles-module-scss-module__3MbW6a__article_image",
  "article_link": "styles-module-scss-module__3MbW6a__article_link",
  "icon_container": "styles-module-scss-module__3MbW6a__icon_container",
  "theme_carousel": "styles-module-scss-module__3MbW6a__theme_carousel",
  "theme_community": "styles-module-scss-module__3MbW6a__theme_community",
  "theme_cta": "styles-module-scss-module__3MbW6a__theme_cta",
  "theme_primary": "styles-module-scss-module__3MbW6a__theme_primary",
});
